import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const AzerbaijanPage = () => {
  return <DestinationTemplate destinationId="azerbaijan" />;
};

export default AzerbaijanPage;
